import { StoryItem } from '@/models/story-item.model';
import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Story } from '@/models/story.model';
import { PaginationResult } from '@/models/pagination.model';

class StoriesService extends BaseService {
  private url: string = '/api/story';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Story>> {
    const res = await this.$http.get<Story>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getStoryForType(
    type: string,
    id: number,
  ): Promise<DataResponse<Story>> {
    const res = await this.$http.get<Story>(`${this.url}/${type}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Story[]>> {
    const res = await this.$http.get<Story[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(Story: Partial<Story>): Promise<DataResponse<Story>> {
    const res = await this.$http.post<Story>(this.url, Story);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(Story: Story): Promise<DataResponse<Story>> {
    const res = await this.$http.put<Story>(`${this.url}/${Story.id}`, Story);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async editStructure(item: StoryItem): Promise<DataResponse<Story>> {
    const res = await this.$http.put<Story>(
      `${this.url}/${item.story.id}/structure`,
      item,
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async updateOrder(order: number[]): Promise<DataResponse<Story[]>> {
    const res = await this.$http.put<Story[]>(
      `${this.url}/order`,
      order.map((id, index) => ({ id, index })),
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }

  public async search(
    search: string,
    page: number = 0,
    categoryId?: number,
  ): Promise<PaginationResult<Story>> {
    const res = await this.$http.get<PaginationResult<Story>>(
      `${this.url}/paginated?search=${search}${
        categoryId ? `&categories=${categoryId}` : ''
      }&page=${page}&count=10`,
    );

    return res.data;
  }
}

export default new StoriesService();
